export enum ValuationMethod {
FIFO,
LIFO,
Average,
}
